import React, { PureComponent } from 'react';
import { TransitionWrapper } from '@tencent/workbench';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import i18n from '@i18next/i18n';
import ua from '@tencent/docs-user-agent';
import style from './toggle.less';
import TOOLBAR_UNFOLD from '@tencent/docs-design-resources/pc/svg/toolbar_unfold.svg';

interface IImmersiveToggleButtonProps {
    handleButtonClick: () => void;
}

/** 沉浸态浮动在页面右上角的 切换按钮 */
export class ImmersiveToggleButton extends PureComponent<IImmersiveToggleButtonProps> {
    public handleMouseMove = (e: React.MouseEvent) => {
        e.nativeEvent.stopImmediatePropagation();
    };

    render() {
        return (
            <Tooltip
                title={`${i18n.t('展开工具栏')} (${ua.isMac ? '⌘+F1' : 'Ctrl+F1'})`}
                key="immersive-toggle-tooltip"
                trigger={'hover'}
                className={style['immersive-toggle-wrapper-tooltip']}
                placement={'bottom'}
                alignment={'end'}
                containerOffsetY={24}
            >
                <TransitionWrapper name="unfold" style={{}}>
                    <div
                        role={'button'}
                        tabIndex={0}
                        aria-label={i18n.t('展开工具栏')}
                        onClick={this.props.handleButtonClick}
                        onMouseMove={this.handleMouseMove}
                        className={style['immersive-toggle-wrapper']}
                        onKeyDown={this.handleKeyDown}
                    ><img src={TOOLBAR_UNFOLD}/></div>
                </TransitionWrapper>
            </Tooltip>
        );
    }

    private handleKeyDown = (event: React.KeyboardEvent) => {
        if (event.key === 'Enter' || event.key === 'Space') {
            this.props.handleButtonClick();
        }
    };
}
